// src/hooks/useAuth.js
import { useContext } from 'react';
import AuthContext from '../context/AuthContext';

const useAuth = () => {
  const { user, selectedSite, setSelectedSite, selectedSiteName, setSelectedSiteName, login, logout, loading } = useContext(AuthContext);
  
  return {
    user,
    selectedSite,
    setSelectedSite,
    selectedSiteName,
    setSelectedSiteName,
    login,
    logout,
    loading
  };
};

export default useAuth;